import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcExpandMore20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m4.994 7a.998.998 0 0 0 -.994.995c0 .266.133.531.298.697l5.006 5.01c.199.198.464.298.696.298a.936.936 0 0 0 .62-.22l5.082-5.088c.199-.166.298-.431.298-.697a.998.998 0 0 0 -.994-.995c-.266 0-.53.1-.73.299l-4.276 4.28-4.276-4.28a1.028 1.028 0 0 0 -.73-.299z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcExpandMore20;
